import React, { useEffect, useState } from 'react';

const N8NEmbeddedForm = () => {
  const [frameHeight, setFrameHeight] = useState('100vh');

  useEffect(() => {
    const calculateHeight = () => {
      const footer = document.querySelector('.footer');
      const footerHeight = footer ? footer.offsetHeight : 0;
      const availableHeight = window.innerHeight - footerHeight - 16;
      setFrameHeight(`${availableHeight}px`);
    };

    calculateHeight();
    window.addEventListener('resize', calculateHeight);
    return () => window.removeEventListener('resize', calculateHeight);
  }, []);

  return (
    <div className="relative w-full h-full flex justify-center">
      <div className="w-full max-w-7xl px-4 md:px-6 lg:px-8">
        <iframe
          src="https://n8n.gettechlab.com/form/restpocket_input"
          title="n8n Form"
          className="w-full bg-white rounded-lg shadow-lg"
          style={{ 
            height: frameHeight,
            minWidth: '320px', // Minimum width on mobile
          }}
          frameBorder="0"
          allowFullScreen
        />
      </div>
    </div>
  );
};

export default N8NEmbeddedForm;
